import axios from 'axios';
import Cookies from 'js-cookie';
// const apiKey = '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';
// const apiKey = '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';
const apiKey = 'AIzaSyDUW8zM8optn_nQh2G-_wIGD9p5jkncKqw';


// const apiUrl = 'https://api.openai.com/v1/chat/completions';
// const apiUrl = 'https://api.openai.com/v1/dalle-generate'; //error
// const apiUrl = 'https://images.unsplash.com/photo-1532974297617-c0f05fe48bff?w=500&auto=format&fit=crop&q=60';
const apiUrl = 'https://generateaivideo.stellans.com/api/gen_pixelimage.php';
// const apiUrl = 'https://api.openai.com/v1/images/edits';
const apivURL = 'https://generateaivideo.stellans.com/api/getaudio.php';
//const [audioSrc, setAudioSrc] = useState('1');

const { GoogleGenerativeAI } = require("@google/generative-ai");

const resType = true;

export const generateScript = async (topic) => {
    // Access your API key (see "Set up your API key" above)
    const genAI = new GoogleGenerativeAI('AIzaSyDUW8zM8optn_nQh2G-_wIGD9p5jkncKqwghffggf');
    
    try {
        // Updated to gemini-2.5-flash based on user dashboard availability (5 RPM limit)
        const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash"});
        
        const prompt = `Create a compelling video script for a social media reel about: ${topic}

Format it exactly as follows:



Write a short, engaging script (30-50 words) that tells a compelling story about ${topic}. Make it engaging, shareable, and suitable for TikTok, Instagram Reels, or YouTube Shorts. Include visual cues in brackets if needed.

Make it professional, engaging, and ready to use immediately.`;
        
        const result = await model.generateContent(prompt);
        const response = await result.response;
        const text = response.text();
        
        return text;
    } catch (error) {
        console.warn("Gemini API Error (Quotas/Network):", error.message);
        // Fallback continues below...
        
        // FALLBACK: Generate local script if API fails
        console.log("Falling back to local script generation due to API error.");
        
        const fallbackScripts = [
            `Unlock the magic of ${topic}. Experience innovation meets tradition in every moment. Join thousands discovering what's truly possible. Start your journey today!`,
            `What makes ${topic} extraordinary? Discover the perfect blend of quality, style, and substance. Transform your perspective. Don't miss this opportunity!`,
            `${topic} redefined. From concept to reality, witness the evolution of excellence. Explore what's next. Your best experience awaits!`,
            `Experience ${topic} like never before. Where passion meets precision, creating something unforgettable. Ready to be amazed? Let's go!`,
            `The future of ${topic} is here. Combining innovation with elegance, creating moments that matter. Discover the difference today!`
        ];
        
        // Pick a random fallback script
        return fallbackScripts[Math.floor(Math.random() * fallbackScripts.length)];
    }
};

export const generateImaged3 = async (formData) => {
    // Save script text to cookie immediately to ensure it's available for next steps
    if (formData.question) {
        Cookies.set('scripttxt', formData.question);
    }

    // ---------------------------------------------------------
    // PRIMARY: GEMINI (IMAGEN 3) INTEGRATION
    // ---------------------------------------------------------
    const GEMINI_API_KEY = 'AIzaSyDUW8zM8optn_nQh2G-_wIGD9p5jkncKqw'; 
    const GEMINI_API_URL = `https://generativelanguage.googleapis.com/v1beta/models/imagen-3.0-generate-001:predict?key=${GEMINI_API_KEY}`;
    
    try {
        if (GEMINI_API_KEY && !GEMINI_API_KEY.includes('YOUR_GEMINI')) {
            const mergerequest = "Generate an image that strictly depicts: " + formData.question + ". relating to " + formData.qabout + " Do not include any text inside the images";
            
            console.log("Attempting Gemini Image Gen (Primary)...");
            const geminiResponse = await axios.post(
                GEMINI_API_URL,
                {
                    instances: [{ prompt: mergerequest }],
                    parameters: { sampleCount: 3 } // User has Pro plan, requesting 3 distinct images
                },
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            if (geminiResponse.data && geminiResponse.data.predictions && geminiResponse.data.predictions.length > 0) {
                 console.log(`%c 🟢 GEMINI SUCCESS: ${geminiResponse.data.predictions.length} Images generated via Imagen 3`, "background: #222; color: #00ff00; font-size:12px; padding: 4px;");
                 
                 // Map all predictions to the format expected by the UI
                 const uniqueImages = geminiResponse.data.predictions.map(pred => {
                     const mimeType = pred.mimeType || 'image/png';
                     return {
                         url: `data:${mimeType};base64,${pred.bytesBase64Encoded}`,
                         source: 'gemini'
                     };
                 });
                 
                 // If we got fewer than 3, duplicate the last one to fill
                 while (uniqueImages.length < 3) {
                     uniqueImages.push(uniqueImages[0]);
                 }
                 
                 return uniqueImages;
            }
        }
    } catch (geminiError) {
        console.warn("Gemini (Primary) failed, falling back to Stellans/PHP.", geminiError.message);
        // Continue to existing code execution (fallback)
    }

    // ---------------------------------------------------------
    // FALLBACK 1: STELLANS PHP API
    // ---------------------------------------------------------
    const promises = [];
    const resdata = [];

    try {
        if (resType) {
            for (let i = 0; i < 3; i++) {
                // Add explicit variation instruction to prompt to avoid duplicate images
                const variationDetails = [
                    "style: photorealistic, wide angle",
                    "style: cinematic, dramatic lighting",
                    "style: vibrant colors, close-up details"
                ];
                const variedPrompt = "Generate an image that strictly depicts: " + formData.question + ". relating to " + formData.qabout + " Do not include any text inside the images" + ` ${variationDetails[i] || "different perspective"}`;

                // Call PHP backend service (no API key needed for PHP)
                promises.push(
                    axios.post(
                        apiUrl,
                        {
                            model: 'dall-e-2',
                            prompt: variedPrompt,
                            size: "1024x1024",
                            n: 1
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                        }
                    )
                );
            } // for end

        } else {
             // FALLBACK: Return 3 DIFFERENT images
             const fallbackImages = [
                 "https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=500&auto=format&fit=crop", // Abstract/Colorful
                 "https://images.unsplash.com/photo-1532974297617-c0f05fe48bff?w=500&auto=format&fit=crop", // Car/Tech (Example)
                 "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=500&auto=format&fit=crop"  // Nature
             ];
             
             for (let i = 0; i < 3; i++) {
                promises.push(
                    Promise.resolve({
                        "data": {
                            "created": Date.now(),
                            "data": [
                                {
                                    "url": fallbackImages[i] || fallbackImages[0]
                                }
                            ]
                        }
                    })
                );
            }
        }


        const responses = await Promise.all(promises);
        console.log('API Responses:', responses);

        for (let i = 0; i < responses.length; i++) {
             // robustness check
             if (responses[i].data && responses[i].data.data && responses[i].data.data.length > 0) {
                 resdata.push(responses[i].data.data[0]);
             } else {
                 console.warn('Unexpected response structure:', responses[i], i);
             }
        }
        
        // Filter for unique URLs to prevent duplicates
        const uniqueImages = [];
        const seenUrls = new Set();
        
        for (const item of resdata) {
            if (!seenUrls.has(item.url)) {
                seenUrls.add(item.url);
                uniqueImages.push(item);
            }
        }
        
        // If we have at least one image but fewer than 3, duplicate to ensure consistency (User request: "exact same")
        if (uniqueImages.length > 0 && uniqueImages.length < 3) {
             while (uniqueImages.length < 3) {
                 uniqueImages.push(uniqueImages[0]); // Duplicate the first valid image
             }
        }
        
        // If we have ZERO images, strictly use LoremFlickr as absolute fallback
        else if (uniqueImages.length === 0) {
             // Reverting to LoremFlickr as Pollinations.ai is currently down (migration/error images).
             // We strictly filter "stop words" to get the core nouns (e.g., "child with tiger" -> "child,tiger")
             let searchSource = formData.qabout || formData.question || "technology";
             
             // Common words that dilute search results
             const stopWords = ['a', 'an', 'the', 'in', 'on', 'at', 'with', 'by', 'to', 'for', 'of', 'is', 'are', 'was', 'it', 'create', 'image', 'picture', 'photo', 'about'];
             
             // 1. Lowercase and replace non-alphanumeric chars with space
             // 2. Split into words
             // 3. Filter out stop words and very short words (keep 'cat', 'dog', etc.)
             const meaningfulWords = searchSource.toLowerCase()
                                    .replace(/[^\w\s]/g, ' ')
                                    .split(/\s+/)
                                    .filter(w => w.length > 2 && !stopWords.includes(w));

             // Join up to 3 keywords with comma. LoremFlickr uses this for tag searches.
             const keywords = meaningfulWords.slice(0, 3).join(',');
             const safeTopic = keywords || "technology";
             
             // Use random lock numbers to ensure 3 distinct images
             const seed1 = Math.floor(Math.random() * 1000);
             
             const fallbackUrls = [
                `https://loremflickr.com/1024/1024/${safeTopic}/all?lock=${seed1}`,
                `https://loremflickr.com/1024/1024/${safeTopic}/all?lock=${seed1+1}`,
                `https://loremflickr.com/1024/1024/${safeTopic}/all?lock=${seed1+2}`
             ];

             for (let k=0; k < 3; k++) {
                 uniqueImages.push({ url: fallbackUrls[k] });
             }
        }

        // Script text saved at top of function now
        return uniqueImages;

    } catch (error) {
        console.error('Error generating image:', error);
        return null;
    }
};




export const generateImage = async (formData) => {
    // Save script text to cookie immediately to ensure it's available for next steps
    if (formData.question) {
        Cookies.set('scripttxt', formData.question);
    }

    // GEMINI INTEGRATION START
    const GEMINI_API_KEY = 'AIzaSyDUW8zM8optn_nQh2G-_wIGD9p5jkncKqw'; // Corrected Key
    // Use the Imagen 3 endpoint for image generation
    const GEMINI_API_URL = `https://generativelanguage.googleapis.com/v1beta/models/imagen-3.0-generate-001:predict?key=${GEMINI_API_KEY}`; 
    
    // Attempt Gemini Generation
    try {
        if (!GEMINI_API_KEY || GEMINI_API_KEY.includes('YOUR_GEMINI')) {
            throw new Error("Gemini API Key not configured.");
        }

        const mergerequest = "Generate an image that strictly depicts: " + formData.question + ". relating to " + formData.qabout + " Do not include any text inside the images";
        
        // Correct payload for Imagen API
        const geminiResponse = await axios.post(
            GEMINI_API_URL,
            {
                instances: [{ prompt: mergerequest }],
                parameters: { sampleCount: 1 }
            },
            {
                headers: { 'Content-Type': 'application/json' }
            }
        );

        // Check for success and format response
        // Imagen returns: { predictions: [ { bytesBase64Encoded: "...", mimeType: "image/png" } ] }
        if (geminiResponse.data && geminiResponse.data.predictions && geminiResponse.data.predictions.length > 0) {
             console.log("%c 🟢 GEMINI SUCCESS: Image generated via Imagen 3 ", "background: #222; color: #00ff00; font-size:12px; padding: 4px;");
             const base64Data = geminiResponse.data.predictions[0].bytesBase64Encoded;
             const mimeType = geminiResponse.data.predictions[0].mimeType || 'image/png';
             const imageUrl = `data:${mimeType};base64,${base64Data}`;
             
             // Return array of 3 identical or varied images (API usually prompts for 1, we can duplicate or request more if quota allows)
             // For consistency with UI expecting 3:
             return [
                 { url: imageUrl, source: 'gemini' },
                 { url: imageUrl, source: 'gemini' }, // Duplicate for UI fill
                 { url: imageUrl, source: 'gemini' }
             ];
        } else {
             throw new Error("Gemini/Imagen API returned response but no predictions found.");
        }
        
    } catch (error) {
        // Condition: If Gemini limit exceeded (429) or other errors, fallback to PHP file
        const isLimitExceeded = error.response && error.response.status === 429;
        
        if (isLimitExceeded) {
             console.warn("Gemini limit exceeded (429). Falling back to Stellans PHP generation.");
        } else {
             console.warn("Gemini generation failed or not configured/supported. Falling back to Stellans PHP generation.", error.message);
        }
        
        // FALLBACK TO EXISTING LOGIC (Stellans/PHP)
        const genImage = [];
        const resdata = [];
        
        try {
            const mergerequest = "Generate an image that strictly depicts: " + formData.question + ". relating to " + formData.qabout + " Do not include any text inside the images";
            if (resType) {
                const response = await axios.post(
                    apiUrl,
                    {
                        model: 'dall-e-2',
                        prompt: mergerequest,
                        size: "1024x1024",
                        n: 1
    
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${apiKey}`,
                        },
    
                    }
                );
                console.log('Single Image Response:', response);
                if (response?.data) {
                    console.log("%c 🟠 FALLBACK SUCCESS: Image generated via Stellans PHP ", "background: #222; color: #ff8800; font-size:12px; padding: 4px;");
                    // Cookies.set('scripttxt', formData.question); // Removing redundancy
                    // Inject source property to returned items for visibility
                    const resultData = response?.data?.data?.map(item => ({ ...item, source: 'php' }));
                    return resultData;
                }
                genImage.push(
                    {
                        "created": 1707660487,
                        "data": [
                            {
                                "url": "https://images.unsplash.com/photo-1532974297617-c0f05fe48bff?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8MXx8fGVufDB8fHx8fA%3D%3D"
                            }
                        ]
                    }
                );
                const respons = await Promise.all(genImage); 
                if (respons[0]?.data && respons[0].data.length > 0) {
                     resdata.push(respons[0].data[0]);
                }
                return resdata;
            }
        } catch (error) {
            console.error('Error generating image (Fallback):', error);
            return null;
        };
    }
    return null;
}



export const generateVoice = async (formData) => {
    // console.log(formData.question);

    try {
        const response = await axios.post(
            apivURL,
            {
                model: 'tts-1',
                //  prompt: formData.question,
                input: "Do it now and again",
                voice: "onyx",
                speed: 1

            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apiKey}`
                },
            }
        );
        // console.log(response.data);
        if (response?.data) {

            // return response?.data?.data?.[0]?.url
            /* const audioBlob = response.data;
             const audioUrl = URL.createObjectURL(audioBlob);*/
            //setAudioSrc(audioUrl);
            return response?.data;
        }

    } catch (error) {
        console.error('Error generating image:', error);
        return null;
    }
};
